// TPSection.tsx
import React from "react";
import { Grid } from "@mui/material";

import GetEspecialidad from "../../../data/GetEspecialidad";
import GetNivelesTP from "../../../data/GetNivelesTP";
import GetAsignaturasTP from "../../../data/GetAsignaturasTP";

type Especialidad = { id: string; nombre: string };

type Props = {
  especialidadId: string;
  nivelTPId: string;
  asignaturaTPId: string;

  onEspecialidadChange: (esp: Especialidad) => void;
  onNivelChange: (nivel: any) => void;
  onAsignaturaChange: (a: { id: string; nombre: string }) => void;
};

export default function TPSection({
  especialidadId,
  nivelTPId,
  asignaturaTPId,
  onEspecialidadChange,
  onNivelChange,
  onAsignaturaChange,
}: Props) {
  return (
    <>
      <Grid item xs={12} md={4}>
        <GetEspecialidad
          selectedEspecialidadId={especialidadId}
          onEspecialidadChange={onEspecialidadChange}
        />
      </Grid>

      <Grid item xs={12} md={4}>
        <GetNivelesTP
          especialidadId={especialidadId}
          selectedNivelId={nivelTPId}
          onNivelChange={onNivelChange}
        />
      </Grid>

      <Grid item xs={12} md={4}>
        <GetAsignaturasTP
          especialidadId={especialidadId}
          nivelId={nivelTPId}
          selectedAsignaturaId={asignaturaTPId}
          onAsignaturaChange={onAsignaturaChange}
        />
      </Grid>
    </>
  );
}
